export default __webpack_public_path__ + "static/media/T3.e0707dde.mp4";